import * as React from 'react';
import { makeStyles } from '@fluentui/react-components';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    textAlign: 'center',
    padding: '2rem',
    backgroundColor: '#fff8e1',
    color: 'var(--primary-color)',
  },
  errorCode: {
    fontSize: '6rem',
    fontWeight: '700',
    marginBottom: '1rem',
    color: 'var(--error-color)',
  },
  title: {
    fontSize: '2.5rem',
    marginBottom: '1rem',
    lineHeight: '1',
    color: 'var(--primary-color)',
  },
  message: {
    fontSize: '1.2rem',
    marginBottom: '2rem',
    maxWidth: '600px',
    lineHeight: '1.6',
    color: '#6a8ca3',
  },
  validRoutes: {
    backgroundColor: 'rgba(12, 59, 94, 0.1)',
    padding: '1.5rem',
    borderRadius: '12px',
    marginBottom: '2rem',
    border: '2px solid rgba(12, 59, 94, 0.2)',
  },
  routesList: {
    listStyle: 'none',
    padding: 0,
    margin: '1rem 0 0 0',
  },
  routeItem: {
    margin: '0.5rem 0',
  },
  routeLink: {
    color: 'var(--primary-color)',
    textDecoration: 'none',
    fontSize: '1.1rem',
    fontWeight: '500',
    padding: '0.5rem 1rem',
    borderRadius: '6px',
    transition: 'all 0.3s ease',
    display: 'inline-block',
    selectors: {
      '&:hover': {
        backgroundColor: 'var(--primary-color)',
        color: '#fff8e1',
        textDecoration: 'none',
      },
    },
  },
  homeButton: {
    padding: '1rem 2rem',
    fontSize: '1.1rem',
    fontWeight: '600',
    backgroundColor: 'var(--primary-color)',
    color: '#fff8e1',
    textDecoration: 'none',
    borderRadius: '8px',
    border: 'none',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    selectors: {
      '&:hover': {
        backgroundColor: 'var(--primary-hover)',
        transform: 'translateY(-1px)',
      },
    },
  },
  emoji: {
    fontSize: '3rem',
    marginBottom: '1rem',
  },
});

interface ErrorPageProps {
  invalidUrl?: string;
}

const ErrorPage: React.FC<ErrorPageProps> = ({ invalidUrl }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.emoji}>🔍</div>
      <h1 className={classes.errorCode}>404</h1>
      <h2 className={classes.title}>Oops! Page Not Found</h2>
      <p className={classes.message}>
        {invalidUrl 
          ? `The URL "/${invalidUrl}" doesn't exist on our wedding website.` 
          : "The page you're looking for doesn't exist."
        }
        <br />
        But don't worry - our wedding celebration is still happening! 🎉
        Please make sure to use the correct url
      </p>
    </div>
  );
};

export default ErrorPage;